import * as React from "react";
import { Redirect } from "react-router-dom";
import Loader from 'react-loader';
import { toast, ToastContainer} from 'react-toastify';
import {Button, Input} from 'reactstrap';

import { Wrapper, Content, ContentCol , ContentRow, ContentRowSingleCol, InputWrapper} from './SingleTemplate.styles';
import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';

import FroalaEditor from 'react-froala-wysiwyg';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/plugins/colors.min.css'
import 'froala-editor/css/plugins/table.min.css'

import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/table.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/line_height.min.js';
// import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/char_counter.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/font_family.min.js';

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class SingleTemplate extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };

        
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.updateInfo = this.updateInfo.bind(this);
        this.handleChange =  this.handleChange.bind(this);
        this.handleTemplateChange = this.handleTemplateChange.bind(this);
        this.onModelChange = this.onModelChange.bind(this);
    }

    

    public onGoBack() {
        const { history } = this.props;
        // history.goBack();
        // window.history.back();
        const dest = this.props.services.currentBaseUrl + 'templates/';
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        const config = {
            documentReady: true,
            useClasses: true,
            paragraphMultipleStyles: false,
            placeholderText: 'Edit Me',
            fontSizeSelection: true,
            listAdvancedTypes: true,
            fontSize: ['8', '10', '12', '14', '16', '18', '20', '22', '24', '28', '30', '32', '36', '40', '48', '56', '60', '64', '72', '80', '96'],
            fontSizeUnit: 'px',
            fontFamily: {
                "Poppins, sans-serif": "Poppins",
                "Josefin Sans, sans-serif": "Josefin Sans",
                "Roboto,sans-serif": 'Roboto',
                "Oswald,sans-serif": 'Oswald',
                "Montserrat,sans-serif": 'Montserrat',
                "'Open Sans Condensed',sans-serif": 'Open Sans Condensed',
                "'Playfair Display', serif": "Playfair Display"
            },
            toolbarButtons: [
                'fontFamily', 'fontSize', 'inlineStyle', 'insertLink', 'paragraphFormat', 'lineHeight', 'align', 'table', 'color', '|',
                'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|',
                'formatOL', 'formatUL', 'outdent', 'indent', 'quote', , '|',
                'insertLink', 'insertImage', 'embedly', 'insertTable', 'textColor', 'backgroundColor', '|',
                'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|',
                'spellChecker', 'help', '|', 'undo', 'redo'],
            tableResizerOffset: 10,
            tableResizingLimit: 50,
            tableStyles: {
                class1: 'Yellow',
                class2: 'Green',
                class3: 'Blue',
                class4: 'Red'
            },
            colorsText: [
                '#15E67F', '#E3DE8C', '#D8A076', '#D83762', '#76B6D8', 'REMOVE',
                '#1C7A90', '#249CB8', '#4ABED9', '#FBD75B', '#FBE571', '#FFFFFF',
                '#000000'
            ],
            colorsBackground: [
                '#15E67F', '#E3DE8C', '#D8A076', '#D83762', '#76B6D8', 'REMOVE',
                '#1C7A90', '#249CB8', '#4ABED9', '#FBD75B', '#FBE571', '#FFFFFF'
            ],
            colorsStep: 6,
            lineHeights: {
                Default: '',
                Single: '1',
                Double: '2',
                '1.15': '1.15',
                '1.5': '1.5',
                '2.5': '2.5'
            },
            minHeight: 500,
            height: 420,
            pastePlain: false,
            width: 900,
            
        }

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const { params: { id: templateID } } = match;

        const itemInfoRes = await adminAPI.getSingleItemGeneral('data_templates', templateID);
    
        if (itemInfoRes.ok) {
            
            const dataTemplate = itemInfoRes.data;

            this.setState(
                {
                     data: {
                        dataTemplate,
                        config
                     }
                }
            )
        } else {
            toast.error('Error fetching course details!');
        }
    }

    public onModelChange = (model) => {
        const data = this.state.data;
        data.dataTemplate.Datatemplate.html =model;
        this.setState({ data });
    }

    public handleChange(id, e) {
        console.log(e)
        const data = this.state.data
        data.dataTemplate[id] = e.target.value;
        this.setState({
            data
        });
    }

    public handleTemplateChange(e) {
        console.log(e)
        const data = this.state.data
        data.dataTemplate.Datatemplate.html = e.target.value;
        this.setState({
            data
        });
    }

    public async updateInfo() {
        this.setState({
            loaded: false
        });

        const item = this.state.data.dataTemplate;

        const res = await this.props.services.adminAPI.updateItemGeneral('data_templates', item, item.UnstructuredDataTemplateId);

        if (res.ok) {
            toast.success('Update Successful');
        }
        else {
            toast.error('Update Failed')
        }

        this.setState({
            loaded: true
         });
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>
              <Content>
                <ContentRow>

                    <ContentCol>
                        <div>
                            <label htmlFor="title" style={{ display: 'block' }}>
                                Title
                            </label>
                            {/*tslint:disable-next-line jsx-no-lambda*/}
                            <textarea rows={6} cols={38} id="title" value={data.dataTemplate.Name} onChange= {(e) => this.handleChange('Name', e)}/>

                        </div>

                        <div>
                            <label htmlFor="subject" style={{ display: 'block' }}>
                                Subject
                            </label>
                            {/*tslint:disable-next-line jsx-no-lambda*/}
                            <textarea rows={6} cols={38} id="subject" value={data.dataTemplate.TemplateSubject} onChange= {(e) => this.handleChange('TemplateSubject', e)}/>

                        </div>
                    
                    </ContentCol>


                </ContentRow>

                <ContentRowSingleCol>
                    <div>

                    
                        <label htmlFor="description" style={{ display: 'block' }}>
                                Content
                        </label>
                        <FroalaEditor
                            tag='div'
                            config={data.config}
                            model={data.dataTemplate.Datatemplate.html}
                            onModelChange={this.onModelChange}
                            
                        />
                        </div>

                </ContentRowSingleCol>
              </Content>
              <Content>
                <ContentRowSingleCol>
                  <div>
                    <Button onClick={this.updateInfo}>
                      Update
                    </Button>
                  </div>
                </ContentRowSingleCol>
              </Content>
            </Wrapper>    
        );
    
    }

}

export default withServices(SingleTemplate);


// WEBPACK FOOTER //
// ./src/pages/Admin/Templates/SingleTemplate/SingleTemplate.tsx